/** errPage  404 */
import './index.scss'
import React from 'react';
import IconFont from '../../components/IconFont/index'

class ReactEcharts extends React.Component{
  render() {
    return (
      <div className='err-page'>
        <IconFont type='icon-404' />
      </div>
    );
  }
};
export default ReactEcharts;
